document.addEventListener('DOMContentLoaded', function () {
  const makeSelect = document.getElementById('makeSelect');
  const modelSelect = document.getElementById('modelSelect');
  const searchBtn = document.getElementById('firearmSearch');
  const resetBtn = document.getElementById('firearmReset');

  if (!makeSelect || !modelSelect || !searchBtn || !resetBtn) return;

  // Get models data from data attribute
  const sectionEl = document.getElementById('shop-by-firearm');
  const modelsData = sectionEl ? sectionEl.dataset.models : '';
  const models = modelsData ? modelsData.split(',').map((m) => m.trim()) : [];

  // Get wrappers for icon toggle
  const makeWrapper = makeSelect.closest('.firearm-select-wrapper');
  const modelWrapper = modelSelect.closest('.firearm-select-wrapper');

  // Function to update models when make changes
  function updateModels() {
    const selectedMake = makeSelect.value.trim();
    modelSelect.innerHTML = '<option value="">Select Model</option>';

    if (!selectedMake) return;

    // Filter models by prefix (Make--)
    const filtered = models.filter((m) => m.startsWith(selectedMake + '--'));
    filtered.forEach((m) => {
      const modelName = m.replace(selectedMake + '--', '').trim();
      const option = document.createElement('option');
      option.value = modelName;
      option.textContent = modelName;
      modelSelect.appendChild(option);
    });
  }

  // Function to save state to sessionStorage
  function saveState() {
    const state = {
      make: makeSelect.value,
      model: modelSelect.value
    };
    sessionStorage.setItem('firearmState', JSON.stringify(state));
  }

  // Function to restore state from sessionStorage
  function restoreState() {
    const savedState = sessionStorage.getItem('firearmState');
    if (savedState) {
      const state = JSON.parse(savedState);
      if (state.make) {
        makeSelect.value = state.make;
        updateModels();
        if (state.model) {
          // Wait a tick for options to populate
          setTimeout(() => {
            modelSelect.value = state.model;
          }, 0);
        }
      }
    }
  }

  // Restore state on page load
  restoreState();

  // Make select change handler
  makeSelect.addEventListener('change', function () {
    updateModels();
    saveState();
  });

  // Model select change handler
  modelSelect.addEventListener('change', function () {
    saveState();
  });

  // ============================================
  // SEARCH BUTTON (tag-only search)
  // ============================================
  searchBtn.addEventListener('click', function (event) {
    event.preventDefault();

    const make = makeSelect.value.trim();
    const model = modelSelect.value.trim();

    if (!make || !model) {
      alert('Please select both Make and Model.');
      return;
    }

    saveState();

    // This must match the tag you add on the product.
    // Example tag on product: beretta-nano-search
    const tag = `${make}-${model}-search`
      .replace(/\s+/g, '-') // spaces -> dashes
      .toLowerCase();       // search is case-insensitive, but this keeps it consistent

    // Advanced search: restrict to products that have this tag only
    const query = `tag:${tag}`;

    window.location.href = `/search?q=${encodeURIComponent(query)}&type=product`;
  });

  // Reset button handler
  resetBtn.addEventListener('click', function () {
    makeSelect.selectedIndex = 0;
    modelSelect.innerHTML = '<option value="">Select Model</option>';
    sessionStorage.removeItem('firearmState');
  });

  // ============================================
  // DROPDOWN ICON TOGGLE
  // ============================================

  // Make select icon toggle
  if (makeWrapper) {
    makeSelect.addEventListener('mousedown', function () {
      makeWrapper.classList.toggle('open');
    });

    makeSelect.addEventListener('change', function () {
      makeWrapper.classList.remove('open');
    });

    makeSelect.addEventListener('blur', function () {
      setTimeout(() => {
        makeWrapper.classList.remove('open');
      }, 150);
    });
  }

  // Model select icon toggle
  if (modelWrapper) {
    modelSelect.addEventListener('mousedown', function () {
      modelWrapper.classList.toggle('open');
    });

    modelSelect.addEventListener('change', function () {
      modelWrapper.classList.remove('open');
    });

    modelSelect.addEventListener('blur', function () {
      setTimeout(() => {
        modelWrapper.classList.remove('open');
      }, 150);
    });
  }
});